import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import SEOHead from '@/components/feature/SEOHead';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

export default function CategoryPage() {
  const categoryPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '韩漫分类大全 - 韩国漫画网',
    description: '浏览韩国漫画网的全部漫画分类，包括恋爱、奇幻、动作、悬疑、校园、穿越、耽美、竞技等多种类型韩漫。',
    url: 'http://dakunkj.cn/category',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(categoryPageSchema)}</script>
      <SEOHead />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-20">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '全部分类' },
              ]}
            />

            <div className="mt-8">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                韩漫分类大全
              </h1>
              <p className="mt-3 text-sm text-foreground-600 max-w-2xl">
                浏览全部韩国漫画分类，找到您感兴趣的漫画类型。我们提供丰富的分类体系，让您轻松发现好看的韩国漫画。
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-6 transition-all duration-300 hover:border-primary-200 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-lg group-hover:bg-accent-200 transition-colors duration-300">
                    <i className={`${cat.icon} text-2xl text-accent-600`}></i>
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-foreground-900 mt-4 group-hover:text-primary-500 transition-colors duration-200">
                    {cat.name}韩漫
                  </h2>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                    {cat.description}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{cat.count} 部作品</span>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap flex items-center gap-1">
                      浏览分类
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}